import { render } from "./SetExpirationDateHoldRequestModal.vue?vue&type=template&id=031b67fd&scoped=true&ts=true&lang=pug"
import script from "./SetExpirationDateHoldRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetExpirationDateHoldRequestModal.vue?vue&type=script&setup=true&lang=ts"

import "./SetExpirationDateHoldRequestModal.vue?vue&type=style&index=0&id=031b67fd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031b67fd"]])

export default __exports__